import axios from './axios'

    

export async function sendEmail(params: String) {

    const response = await axios.post(`/api/sendMail`, params);
    return response;
}